module.exports = __webpack_public_path__ + "static/img/top-bgc2.dbb74003.png";